"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DVCVariable = void 0;
var utils_1 = require("./utils");
var DVCVariable = /** @class */ (function () {
    function DVCVariable(variable) {
        var key = variable.key, defaultValue = variable.defaultValue;
        (0, utils_1.checkParamType)('key', key, 'string');
        (0, utils_1.checkParamDefined)('defaultValue', defaultValue);
        this.key = variable.key;
        this.isDefaulted = variable.value === undefined || variable.value === null;
        this.value = this.isDefaulted
            ? variable.defaultValue
            : variable.value;
        this.defaultValue = variable.defaultValue;
        this.evalReason = variable.evalReason;
    }
    DVCVariable.prototype.onUpdate = function (callback) {
        (0, utils_1.checkParamType)('callback', callback, 'function');
        this.callback = callback;
        return this;
    };
    return DVCVariable;
}());
exports.DVCVariable = DVCVariable;
//# sourceMappingURL=Variable.js.map